export const btnStyles = {
  borderRadius: '4px',
  width: '100%',
  maxWidth: '281px',
  width: '50px',
  gridColumn: 2,
}

export const popperStyles = {
  textAlign: 'center',
  '&>div': { maxWidth: 'max-content' },
}
